import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Form, Input } from 'reactstrap';
import { getStickers } from '../../api';

function getValues(order, autoSave) {
	return {
		cod: order.cod || (autoSave ? '' : 'NO'),
		delivery: order.delivery || (autoSave ? '' : 'TARGOFLEX'),
		term: order.term || (autoSave ? '' : 'DDP'),
		modified: false,
		_id: order._id
	};
}

async function saveAndPrint(abc, cod, delivery, term, print, onData, setState, setValues) {
	try {
		const stickers = await Promise.all(abc.map(async ({ _id }) => {
			const data = await getStickers({
				order: _id,
				cod: cod || null,
				delivery: delivery || null,
				term: term || null,
				print
			});
			data.date = new Date(data.date);
			return data;
		}));
		if(onData) {
			onData(stickers);
		}
		setValues(prev => ({ ...prev, modified: false }));
	} catch(err) {
		console.error('Failed to get stickers', err);
		window.alert('Er is een fout opgetreden');
	}
	setState(prev => ({ ...prev, submitting: false, print: onData ? print : false }));
}

function DeliveryForm({ codList, deliveryList, terms, className, children, order, onData, abc, post = null }) {
	const [values, setValues] = useState(() => getValues(order, !onData));
	const { cod, delivery, term } = values;
	const [state, setState] = useState({ submitting: false, print: !!onData });
	useEffect(() => {
		setValues(prev => {
			if(prev._id !== order._id || !prev.modified) {
				return getValues(order, !onData);
			}
			return prev;
		});
	}, [order, onData]);
	function submit(e) {
		if(e) {
			e.preventDefault();
		}
		const { print } = state;
		setState(prev => ({ ...prev, submitting: true }));
		saveAndPrint(abc, cod, delivery, term, print, onData, setState, setValues);
		setValues(prev => ({ ...prev, modified: false }));
	}
	return <Form onSubmit={submit} className={className}>
		{children}
		<dl className="row mb-0">
			<dt className="col-6 col-md-4">Cash on Delivery</dt>
			<dd className="col-6 col-md-8">
				<Input type="select" value={cod} onChange={e => setValues(prev => ({ ...prev, cod: e.target.value, modified: true } ))} required>
					<option value="" disabled>---</option>
					{codList.map(option => <option key={option} value={option}>
						{option}
					</option>)}
				</Input>
			</dd>
			<dt className="col-6 col-md-4">Delivery Option</dt>
			<dd className="col-6 col-md-8">
				<Input type="select" value={delivery} onChange={e => setValues(prev => ({ ...prev, delivery: e.target.value, modified: true }))} required>
					<option value="" disabled>---</option>
					{deliveryList.map(option => <option key={option.id} value={option.id}>
						{option.description}
					</option>)}
				</Input>
			</dd>
			<dt className="col-6 col-md-4">Incoterm</dt>
			<dd className="col-6 col-md-8">
				<Input type="select" value={term} onChange={e => setValues(prev => ({ ...prev, term: e.target.value, modified: true }))} required>
					<option value="" disabled>---</option>
					{terms.map(option => <option key={option.id} value={option.id}>
						{option.description}
					</option>)}
				</Input>
			</dd>
		</dl>
		<label className="d-block">
			<input type="checkbox" checked={state.print} onChange={e => setState(prev => ({ ...prev, print: e.target.checked }))} /> Stuur naar label printer
		</label>
		{post && post(state.submitting)}
	</Form>;
}

export default connect(({ person, cod, delivery, terms }) => {
	return { person, codList: cod, deliveryList: delivery, terms };
})(DeliveryForm);
